import { Component, HostBinding, OnInit } from '@angular/core';

import { navItems, navComponentItems, navStaffItems, navAdminItems, navCoachItems } from './_nav';
import { environment } from '../../../environments/environment'
import { StorageService } from '../../services/storege-service/storage.service';
import { UserTranslationService } from '../../services/user-translation/user-translation.service';
import * as _ from 'lodash';
import { ToolService } from '../../services/tool/tool.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent implements OnInit {
  @HostBinding('class.c-app') cAppClass = true;

  public navItems = [];
  public navStaffItems = [];
  public navCoachItems = [];
  public navAdminItems = [];
  isComponentsSidenavEnabled: boolean = false;

  public navComponentItems = navComponentItems;
  public env = environment;
  public isStaff = true;
  public isAdmin = false;
  public userType = '';
  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  constructor(
    private storageSrv: StorageService,
    private userTranslationService: UserTranslationService,
    public toolService: ToolService,
  ) {
    this.isStaff = this.storageSrv.getIsStaff() === '1' ? true : false;
    this.isAdmin = this.storageSrv.getType() === 'admin' ? true : false;
    this.userType = this.storageSrv.getType();
  }

  ngOnInit(): void {
    this.translateSideLinks();
    this.userTranslationService.languageSubject.subscribe(() => {
      this.translateSideLinks();
    });
  }

  translateSideLinks() {
    const translateNavItems = (navItems) => {
      const navItemsList = _.cloneDeep(navItems);
      return navItemsList.map((navItem) => {
        navItem['name'] = this.userTranslationService.translateText('AppRouteTitles.' + navItem?.name);
        if (navItem?.children) {
          navItem['children'] = navItem.children.map((childItem) => {
            childItem['name'] = this.userTranslationService.translateText('AppRouteTitles.' + childItem?.name);
            return childItem;
          });
        }
        return navItem;
      });
    };
    setTimeout(() => {
      this.navItems = translateNavItems(navItems);
      this.navStaffItems = translateNavItems(navStaffItems);
      this.navCoachItems = translateNavItems(navCoachItems);
      this.navAdminItems = translateNavItems(navAdminItems);
    }, 500);
  }


}
